import * as React from "react";
import { styled } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
//region [[ Styles ]]

const Indicator = styled("div")({
  height: "6px",
  width: "2px",
  background: KahunColorMap.Default,
  bottom: "100%",
  position: "absolute",
});

const RangeViewContainer = styled("div")({
  display: "inline-block",
  position: "relative",
  width: "104px",
  height: "2px",
  background: KahunColorMap.Default,
  margin: "15px",
});

interface AffectiveRangeProps {
  startPoint: number;
  endPoint: number;
}
const AffectiveRange = styled("div")((props: AffectiveRangeProps) => ({
  position: "relative",
  left: `${props.startPoint}%`,
  height: "5px",
  background: KahunColorMap.Default,
  width: `calc(${props.endPoint - props.startPoint}% + 1px)`,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-evenly",
}));

const RangeLabel = styled("div")({
  color: KahunColorMap.Default,
  marginTop: "5px",
  fontSize: "0.8em",
});

const RangeFirst = styled("div")({
  position: "absolute",
  left: 0,
});
const RangeFirstLabel = styled(RangeLabel)({
  marginLeft: "-50%",
});

const RangerFrstIndicator = styled(Indicator)({
  left: 0,
});

const RangeLast = styled("div")({
  position: "absolute",
  right: 0,
});

const RangeLastLabel = styled(RangeLabel)({
  marginLeft: "50%",
});

const RangeLastIndicator = styled(Indicator)({
  right: 0,
});

const MainValue = styled("div")((props: { value: number }) => ({
  position: "absolute",
  left: `calc(${props.value}% - 1px)`,
  bottom: "calc(100% - 5px)",
  display: "flex",
  flexDirection: "column-reverse",
  justifyContent: '""',
  alignItems: "left",
}));

const MainValueLabel = styled("div")({
  color: KahunColorMap.Primary,
});

const MainIndicator = styled(Indicator)({
  height: "7px",
  width: "3px",
  background: KahunColorMap.Accent,
  bottom: 0,
  zIndex: 2,
  position: "relative",
});

//endregion [[ Styles ]]

//region [[ Props ]]

interface RangeViewProps {
  startRangeMark?: { value: number; label: string };
  endsRangeMark?: { value: number; label: string };
  mainValue: number;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
export const RangeView = ({ ...props }: RangeViewProps) => {
  return (
    <RangeViewContainer>
      {props.startRangeMark && props.endsRangeMark && (
        <AffectiveRange
          startPoint={props.startRangeMark.value}
          endPoint={props.endsRangeMark.value}
        >
          <RangeFirst>
            <RangeFirstLabel>{props.startRangeMark.label}</RangeFirstLabel>
            <RangerFrstIndicator />
          </RangeFirst>
          <RangeLast>
            <RangeLastLabel>{props.endsRangeMark.label}</RangeLastLabel>
            <RangeLastIndicator />
          </RangeLast>
        </AffectiveRange>
      )}
      <MainValue value={props.mainValue}>
        <MainIndicator />
        <MainValueLabel>{props.mainValue}%</MainValueLabel>
      </MainValue>
    </RangeViewContainer>
  );
};
